import Vuex from "vuex";

const store = new Vuex.Store({
    state: {
        status: localStorage.getItem('status') || false,
        key: localStorage.getItem('key') || '',
        server: localStorage.getItem('server') || '',
        email: localStorage.getItem('email') || '',
        user: localStorage.getItem('user') || '',
        version: localStorage.getItem('version') || '',
        userTimezone: localStorage.getItem('user_timezone') || '',
        theme: localStorage.getItem('theme') || '',
        permissions: {},
        statuspages: false,
        canSubmitCommands: false,
        canDeleteDowntimes: false,
        canDeleteAcknowledgements: false,
        hostsIndexFilter:{},
        servicesIndexFilter:{},
        contactInfo: {}
    },
    actions: {},
    mutations: {
        setState(state, value){
            state.status = value;
        },
        setKey(state, value){
            state.key = value;
        },
        setServer(state, value){
            state.server = value;
        },
        setEmail(state, value){
            state.email = value;
        },
        setUser(state, value){
            state.user = value;
        },
        setVersion(state, value){
            state.version = value;
        },
        setUserTimezone(state, value){
            state.userTimezone = value;
        },
        setTheme(state, value){
            state.theme = value;
        },
        setPermissions(state, value){
            state.permissions = value;
        },
        setStatuspages(state,value) {
            state.statuspages = value;
        },
        setCanSubmitCommands(state, value){
            state.canSubmitCommands = value;
        },
        setCanDeleteDowntimes(state, value){
            state.canDeleteDowntimes = value;
        },
        setCanDeleteAcknowledgements(state, value){
            state.canDeleteAcknowledgements = value;
        },
        setHostsIndexFilter(state, value) {
            state.hostsIndexFilter = value;
        },
        setServicesIndexFilter(state, value) {
            state.servicesIndexFilter = value;
        },
        setContactInfo(state, value) {
            state.contactInfo = value;
        }
    },
    getters: {},
    modules: {},
});

export default store;
